import { TStyles } from "utils/Styles";

const styles: TStyles = {
  autocomplete: {
    ".MuiIconButton-root": {
      mr: "-4px",

      ".MuiSvgIcon-root": {
        pt: "2px",
      },
    },
  },
  option: {
    whiteSpace: "normal",
  },
  noWrapOption: {
    whiteSpace: "noWrap",
  },
};

export default styles;
